(function (angular) {
    angular.module('app').directive('form', function () {
        return {
            restrict: 'E',
            link: function (scope, elem) {
                elem.on('submit', function () {
                    if ($('body').hasClass('mobile')) {
                        var elements = 'input[type="text"],input[type="password"],input[type="date"],input[type="number"],input[type="email"],select,textarea';
                        elem.find(elements).blur();
                    }

                    scope.$broadcast('form:submit');
                });
            }
        };

    });
})(angular);